<template>
  <div>
    <div>
      <div class="card">
        <div class="card-header">
          <div class="row">
            <div class="col-sm-12 col-md-12 col-xl-12">
              <h4 class="card-title">
                Users
                <router-link
                  v-show="isSuperAdministrator"
                  class="btn btn-sm btn-primary float-right"
                  :to="{ name: 'UserCreate' }"
                  >Create
                </router-link>
              </h4>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 col-md-3 col-xl-3">
              <input
                type="text"
                id="searchEmail"
                placeholder="Search Email"
                class="form-control"
                v-model="search.email"
              />
              <small
                v-show="search.email !== null"
                @click="() => clearSelected('email')"
                class="float-left form-text text-muted"
                >clear email</small
              >
            </div>
            <div class="col-sm-12 col-md-3 col-xl-3">
              <vue-select
                id="selectLimit"
                name="selectLimit"
                class="form-control"
                placeholder="--- Select namespace ---"
                v-model="search.namespace"
                :options="search.namespaces"
                close-on-select
                :empty-model-value="null"
              ></vue-select>
              <small
                v-show="search.namespace !== null"
                @click="() => clearSelected('namespace')"
                class="float-left form-text text-muted"
                >clear namespace</small
              >
            </div>
            <div class="col-sm-12 col-md-3 col-xl-3">
              <vue-select
                id="selectLimit"
                name="selectLimit"
                class="form-control"
                placeholder="--- Select role ---"
                :empty-model-value="''"
                v-model="search.role"
                :options="search.roles"
                close-on-select
              ></vue-select>
              <small
                v-show="search.role !== null"
                @click="() => clearSelected('role')"
                class="float-left form-text text-muted"
                >clear role</small
              >
            </div>
            <div class="col-sm-12 col-md-3 col-xl-3">
              <vue-select
                id="selectLimit"
                name="selectLimit"
                class="form-control"
                placeholder="--- Select status ---"
                v-model="search.status"
                :options="search.statuses"
                close-on-select
              ></vue-select>
              <small
                v-show="search.status !== null"
                @click="() => clearSelected('status')"
                class="float-left form-text text-muted"
                >clear status</small
              >
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 col-md-3 col-xl-3">
              <div class="form-group" data-children-count="1">
                <label class="">Limit</label>
                <vue-select
                  id="selectLimit"
                  name="selectLimit"
                  class="form-control"
                  v-model="pagination.limit"
                  :options="pagination.limits"
                  close-on-select
                ></vue-select>
              </div>
            </div>
            <div class="col-sm-12 col-md-3 col-xl-3">
              <label for="page" class="">Current Page</label
              ><input
                id="page"
                placeholder="Page"
                min="0"
                :max="pagination.pages"
                type="number"
                class="form-control"
                v-model="pagination.page"
              />
            </div>
            <div class="col-sm-12 col-md-3 col-xl-3">
              <label for="pages" class="">Pages</label
              ><input
                id="pages"
                readonly=""
                type="number"
                class="form-control"
                v-model="pagination.pages"
              />
            </div>
            <div class="col-sm-12 col-md-3 col-xl-3">
              <label for="total" class="">Total</label
              ><input
                id="total"
                readonly=""
                type="number"
                class="form-control"
                v-model="pagination.total"
              />
            </div>
          </div>
        </div>
        <div class="card-body">
          <div class="row">
            <div
              class="border-top border-bottom p-1 col-sm-12 col-md-4 col-xl-4"
            >
              EMAIL
            </div>
            <div
              class="border-top border-bottom p-1 col-sm-12 col-md-2 col-xl-2"
            >
              NAMESPACE
            </div>
            <div
              class="border-top border-bottom p-1 col-sm-12 col-md-2 col-xl-2"
            >
              ROLE
            </div>
            <div
              class="border-top border-bottom p-1 col-sm-12 col-md-2 col-xl-2"
            >
              STATUS
            </div>
            <div
              class="border-top border-bottom p-1 col-sm-2 col-md-2 col-xl-2"
            >
              <span class="float-right">ACTION</span>
            </div>
          </div>

          <div v-for="user in users" :key="user.id">
            <div class="row">
              <div
                class="border-top border-bottom p-1 col-sm-12 col-md-4 col-xl-4"
              >
                {{ user.email }}
              </div>
              <div
                class="border-top border-bottom p-1 col-sm-12 col-md-2 col-xl-2"
              >
                {{ user.namespace }}
              </div>
              <div
                class="border-top border-bottom p-1 col-sm-12 col-md-2 col-xl-2"
              >
                {{ user.role }}
              </div>
              <div
                class="border-top border-bottom p-1 col-sm-12 col-md-2 col-xl-2"
              >
                {{ user.status }}
              </div>
              <div
                class="border-top border-bottom p-1 col-sm-2 col-md-2 col-xl-2"
              >
                <div role="group" class="float-right btn-group">
                  <router-link
                    class="btn btn-success btn-sm"
                    :to="{ name: 'UserEdit', params: { id: user.id } }"
                    >Edit</router-link
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card-footer">Footer</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  getUsers,
  namespaceList,
  roleList,
  statusList,
} from "../../controllers/user-contoller";

export default {
  data: () => {
    return {
      search: {
        email: null,
        namespace: null,
        namespaces: namespaceList,
        role: null,
        roles: roleList,
        status: null,
        statuses: statusList,
      },
      pagination: {
        limit: 10,
        page: 1,
        limits: [1, 5, 10, 15, 50, 100],
        pages: 1,
        total: 0,
      },
      users: [],
    };
  },
  computed: {
    ...mapGetters([
      "isSuperAdministrator",
    ]),
  },
  created() {
    try {
      this.updateUsers();
    } catch (e) {
      console.log(e);
    }
  },
  watch: {
    search: {
      deep: true,
      handler() {
        this.updateUsers();
      },
    },
    "pagination.limit"() {
      this.updateUsers();
    },
    "pagination.page"() {
      this.updateUsers();
    },
  },
  methods: {
    updateUsers() {
      setTimeout(async () => {
        const { users, pagination } = await getUsers(
          this.search,
          this.pagination
        );
        this.users = users;
        this.pagination.total = pagination.total;
        this.pagination.pages = pagination.lastPage;
      }, 50);
    },
    clearSelected(type) {
      switch (type) {
        case "email":
          this.search.email = null;
          break;
        case "namespace":
          this.search.namespace = null;
          break;
        case "role":
          this.search.role = null;
          break;
        case "status":
          this.search.status = null;
          break;
      }

      setTimeout(async () => {
        this.users = await getUsers(this.search, this.pagination);
      }, 50);
    },
  },
};
</script>
